/*
 * TAKEDA CONFIDENTIAL – Highly Restricted: Do not distribute without prior approval
 *
 * © Copyright (2025) Takeda. All Rights Reserved
 */

import React from 'react';

import { CALCULATOR_PAGE, RESOURCES_PAGE } from '../../navigation/navigation.constants';
import { VdzHeaderLink } from './header-link.component';
import { VdzPrescribingInformation } from './prescribing-information.component';

export const VdzHeaderLinks = () => {
  return (
    <div className="flex flex-col sm:flex-row sm:gap-6 md:gap-12 justify-between items-center">
      <VdzHeaderLink href={CALCULATOR_PAGE} title="footer.calculator.title" />
      <VdzHeaderLink href={RESOURCES_PAGE} title="footer.resources.title" />
      <VdzPrescribingInformation />
    </div>
  );
};
